const isIE = () => !!document.documentMode

export default isIE
